// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3H8VY","name":"Header_name__3uegg","birthday":"Header_birthday__38EHN","skeleton":"Header_skeleton__c8Pdk"};